import React, { useEffect, useState, useMemo } from "react";
import { eventActions } from "../../../_actions";
import { withTranslation, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/Header/Header";
import ".././Dashboard.scss";
import UploadESGSheet from "../../../components/ModalPopup/UploadESGSheet";
// import CustomerTierTable from "./CustomerTierTable";
import CustomerTierSearch from "../../../components/SearchBox/CustomerTierSearch";
import { ToastContainer, toast } from 'react-toastify';
import { isPermission, authorizedMessage } from "../../../_helpers/commonAPI";
import AuthorizedMessagePage from "../../../components/AuthorizedMessagePage";
import ESGCampaignDataGrid from "./ESGCampaignDataGrid";
import esg_campaign_sample_sheet from "./../../../assets/files/esg_campaign_sample_sheet.xlsx";
import { API_URL_ADMIN } from "../../../Constant/index";
import { toCommas } from "../../../_helpers";
import ESGCampaignSearch from "./ESGCampaignSearch";

const ESGCampaign = () => {
    const MyNewClass = useSelector((state) => state.addclasswithstyle.addclasswithstyle);
    const FontChange = useSelector((state) => state.fontsizechanger.fontsizechanger);
    const [esgData, setEsgData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [totalTreesPlanted, setTotalTreesPlanted] = useState("");
    // const [month, setMonth] = useState("");
    const [esgCreated, setEsgCreated] = useState("");
    const [isLoadingTrue, setIsLoadingTrue] = useState(false)
    const [page, setPage] = React.useState(0);
    const [okPermission, setOkPermission] = useState(true)

    async function downloadSample() {
        const isAllow = await isPermission("Esgcampain-MAINPAGE-DOWNLOAD")
        if (!isAllow) {
            toast.success(authorizedMessage, {
                position: toast.POSITION.TOP_RIGHT
            });
            return 0;
        }
        window.location.href = esg_campaign_sample_sheet
        // window.open(esg_campaign_sample_sheet)
    }

    const serchBySoldTo = (serchKey) => {
        const searchData = esgData.filter((item) => {
            return item.accountNumber.includes(serchKey)
        });
        setFilterData(searchData);
        setPage(0);
    }


    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'X-AUTH-TOKEN': localStorage.getItem('x-auth-token')
            },
        };
        setIsLoadingTrue(true)
        fetch(API_URL_ADMIN + `esg`, requestOptions)
            .then((res) => res.json())
            .then((result) => {

                if (result && result.length > 0) {
                    setEsgData(result);
                    setFilterData(result);
                    const ttp = result[0].totalTreesPlanted;
                    setTotalTreesPlanted(toCommas(result[0].totalTreesPlanted));
                    // const monthIndex = result[0].monthYear;
                    // const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    // setMonth(months[monthIndex.split("-")[0]]);
                }
                setIsLoadingTrue(false)
                setEsgCreated("")
                //   if (!result.status) {
                //     const error = (result && result.message) || result.statusText;
                //     return Promise.reject(error);
                //   }
                //   if (result.status === 401) {
                //     const error =result.status;
                //     return Promise.reject(error);
                //   }
                //   return result.data;
            });

    }, [esgCreated])

    // useEffect(() => {
    //     async function checkAuth() {
    //         const isAllow = await isPermission("Esgcampain-MAINPAGE")
    //         if (!isAllow) {
    //             toast.success(authorizedMessage, {
    //                 position: toast.POSITION.TOP_RIGHT
    //             });
    //             return 0;
    //         }
    //         setOkPermission(true)
    //     }
    //     checkAuth()
    // }, [])

    useMemo(async()=>{
        const per =  await isPermission("Esgcampain-MAINPAGE")   
        setOkPermission(per)
    },[])

    return (
        <div className="content-wrapper">
            <Header title="ESG Campaign" />
            <div className={"row ipad_css " + MyNewClass}>
                <div className="mainScroll">
                    {okPermission ?
                        <div className="col-12 view_section">
                            <div className="row mt-2 mb-2" style={{ alignItems: "center" }}>
                                {/* <div className="col-xl-2 col-lg-2 col-md-4 col-sm-12 col-xs-12 text-left guide_month_year">
                                <span><b>Month: </b>
                                    {okPermission && month}
                                </span>
                            </div> */}
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left guide_month_year">
                                    <span><b>Total Number of Trees Planted: </b>
                                        {totalTreesPlanted}
                                    </span>
                                </div>
                                <div className="col-xl-4 col-lg-3 col-md-8 col-sm-12 col-xs-12 mt-2 text-left">
                                    <ESGCampaignSearch serchBySoldTo={serchBySoldTo} setPage={setPage} />
                                </div>
                                <div className="col-xl-4 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-2">
                                    <div className="button_popup">
                                        <button className="add-button" title="Download Template" onClick={downloadSample}> <i class="fa fa-download button-upload" aria-hidden="true"></i> Download</button>
                                        {/* <button className="add-button" title="Download Template" onClick={openToUploadESGSheet}> <i class="fa fa-upload button-upload" aria-hidden="true"></i> ESG Campaign</button> */}
                                        <UploadESGSheet className="ml-3 add-button" title="ESG Campaign" setEsgCreated={setEsgCreated} setIsLoadingTrue={setIsLoadingTrue} />
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive table_design retaiter-table" style={{ fontSize: `${FontChange}px` }}>
                                <ESGCampaignDataGrid filterData={filterData} totalCount={filterData && filterData.length} setEsgCreated={setEsgCreated} isLoadingTrue={isLoadingTrue} page={page} setPage={setPage} />
                            </div>
                        </div>
                        :
                        <AuthorizedMessagePage />
                    }
                </div>
            </div>
        </div>
    )
}

export default ESGCampaign